import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

import ChevronRightSmallSolid from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';

export const ChecksTitle = styled('p')`
  ${({ theme }) => theme.typography.xSmall}
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  margin-right: 4px;
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  span {
    ${({ theme }) => theme.typography.small}
    color: ${({ theme }) => theme.color.white};
  }
  display: none;
  ${media.smUp`
    display: block;
  `}
`;

export const CheckRow = styled(Row)`
  margin: 0 0 ${({ theme }) => theme.x1spacePx}px -${({ theme }) => theme.x1spacePx}px;
  padding: 0 ${({ theme }) => theme.x1spacePx - 4}px 0
    ${({ theme }) => theme.x1spacePx}px;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background: #c4c4c410;
    .checkarrow {
      transform: rotate(90deg);
    }
  }
`;

export const CheckName = styled('p')`
  ${({ theme }) => theme.typography.xSmall}
  margin-bottom: 0px;
  margin-left: ${({ theme }) => theme.x1spacePx}px;
  line-height: 22px;
`;

export const CheckArrow = styled(ChevronRightSmallSolid)`
  height: 1.5em;
  width: 1.5em;
  transition: transform 0.2s;
  margin-left: auto;
`;

export const IconFallback = styled('div')`
  width: 16px;
  height: 24px;
`;
